function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.073 4.5l.585 1.171.415.829H20.5V18h-17V6.5H8l.415-.829L9 4.5h6.073zm0-1.5H9a1.5 1.5 0 00-1.342.829L7.073 5H3.5A1.5 1.5 0 002 6.5V18a1.5 1.5 0 001.5 1.5h17A1.5 1.5 0 0022 18V6.5A1.5 1.5 0 0020.5 5H17l-.585-1.171A1.502 1.502 0 0015.073 3z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 8.5a3.254 3.254 0 013.25 3.25A3.254 3.254 0 0112 15a3.254 3.254 0 01-3.25-3.25A3.254 3.254 0 0112 8.5zM12 7a4.75 4.75 0 100 9.5A4.75 4.75 0 0012 7zM6.5 8H5v1.5h1.5V8z",
  fill: "currentColor"
});

function SvgCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgCameraIcon;